"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersPage = UsersPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var message_1 = require("../../../components/dialogs/message");
var user_1 = require("../../../features/apis/user");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var message_dialog_1 = require("../../../features/thunks/message-dialog");
var hooks_1 = require("../../../store/hooks");
var constants_1 = require("./constants");
var user_form_1 = require("./user-form");
function UsersPage() {
    var _this = this;
    var _a, _b, _c, _d;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _e = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _e.clientId, currentUserId = _e.userId, currentUserRole = _e.role;
    var isAdmin = currentUserRole === "Admin";
    var deleteUser = (0, user_1.useDeleteUserMutation)()[0];
    var registerUser = (0, user_1.useRegisterUserMutation)()[0];
    var _f = (0, react_3.useState)(""), searchQuery = _f[0], setSearchQuery = _f[1];
    var _g = (0, react_3.useState)(""), debouncedSearch = _g[0], setDebouncedSearch = _g[1];
    var _h = (0, react_3.useState)("all"), roleFilter = _h[0], setRoleFilter = _h[1];
    var _j = (0, react_3.useState)("all"), pwdResetFilter = _j[0], setPwdResetFilter = _j[1];
    var _k = (0, react_3.useState)(1), page = _k[0], setPage = _k[1];
    var _l = (0, react_3.useState)(10), rowsPerPage = _l[0], setRowsPerPage = _l[1];
    (0, react_3.useEffect)(function () {
        var timer = setTimeout(function () {
            setDebouncedSearch(searchQuery);
            setPage(1);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [searchQuery]);
    var searchParams = (0, react_3.useMemo)(function () {
        var params = {
            clientId: clientId,
            page: page,
            limit: rowsPerPage,
        };
        if (debouncedSearch)
            params.search = debouncedSearch;
        if (roleFilter !== "all")
            params.role = roleFilter;
        if (pwdResetFilter === "yes")
            params.pwdResetRequired = true;
        else if (pwdResetFilter === "no")
            params.pwdResetRequired = false;
        return params;
    }, [clientId, debouncedSearch, roleFilter, pwdResetFilter, page, rowsPerPage]);
    var _m = (0, user_1.useSearchUsersQuery)(searchParams, { skip: !clientId }), data = _m.data, isLoading = _m.isLoading, isFetching = _m.isFetching;
    var users = (_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.users) !== null && _b !== void 0 ? _b : [];
    var totalItems = ((_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.total) || 0;
    var totalPages = Math.ceil(totalItems / rowsPerPage);
    var handleUserSubmit = function (formPayload) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, registerUser({
                            name: formPayload.name,
                            email: formPayload.email,
                            password: "123456",
                            clientId: clientId,
                            isClientAdmin: formPayload.role === "Admin",
                            gender: formPayload.gender,
                            contactNumber: formPayload.contactNumber,
                        }).unwrap()];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "User Created",
                            description: "User \"".concat(formPayload.name, "\" has been created successfully."),
                            color: "success",
                        });
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Create Failed",
                            description: response.message || "Could not create user.",
                            color: "danger",
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while creating the user.";
                    (0, react_1.addToast)({
                        title: "Create Failed",
                        description: message,
                        color: "danger",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAddUser = function () {
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Add New User",
            content: (0, jsx_runtime_1.jsx)(user_form_1.UserForm, { onSubmit: handleUserSubmit, mode: "create", variant: "dialog" }),
            contentMaxWidth: "max-w-3xl",
            isDismissable: true,
        }));
    };
    var handleDeactivateUser = (0, react_3.useCallback)(function (userId, userName) {
        dispatch((0, message_dialog_1.showMessageDialogThunk)({
            header: "Deactivate User",
            body: "Are you sure you want to deactivate \"".concat(userName, "\"? They will no longer be able to access the system."),
            buttons: [
                {
                    label: "Cancel",
                    type: message_1.EMessageDialogButtonType.CANCEL,
                    variant: "light",
                },
                {
                    label: "Deactivate",
                    type: message_1.EMessageDialogButtonType.OK,
                    variant: "solid",
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var response, error_2, message;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, deleteUser({ userId: userId }).unwrap()];
                                case 1:
                                    response = _b.sent();
                                    if (response.success) {
                                        (0, react_1.addToast)({ title: "User Deactivated", description: "\"".concat(userName, "\" has been deactivated."), color: "success" });
                                    }
                                    else {
                                        (0, react_1.addToast)({ title: "Deactivation Failed", description: response.message || "Could not deactivate user.", color: "danger" });
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_2 = _b.sent();
                                    if (error_2 === "cancel")
                                        return [2 /*return*/];
                                    message = ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while deactivating the user.";
                                    (0, react_1.addToast)({ title: "Deactivation Failed", description: message, color: "danger" });
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                },
            ],
        }));
    }, [dispatch, deleteUser]);
    var handleRowsPerPageChange = function (keys) {
        if (keys !== "all") {
            var value = Array.from(keys)[0];
            setRowsPerPage(Number(value));
            setPage(1);
        }
    };
    var handleClearFilters = function () {
        setSearchQuery("");
        setDebouncedSearch("");
        setRoleFilter("all");
        setPwdResetFilter("all");
        setPage(1);
    };
    var start = totalItems === 0 ? 0 : (page - 1) * rowsPerPage + 1;
    var end = Math.min(page * rowsPerPage, totalItems);
    var renderCell = (0, react_3.useCallback)(function (user, columnKey) {
        var _a, _b;
        switch (columnKey) {
            case "name":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm font-medium text-gray-900", children: user.name });
            case "email":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: user.email });
            case "gender":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: user.gender || "—" });
            case "contactNumber":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: user.contactNumber || "—" });
            case "role":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: (0, constants_1.getRoleColor)(user.role), className: "capitalize", children: user.role }));
            case "permissionsCount":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: (_b = (_a = user.permissions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 });
            case "pwdResetRequired":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: user.pwdResetRequired ? "warning" : "success", children: user.pwdResetRequired ? "Yes" : "No" }));
            case "createdAt":
                return ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: user.createdAt ? new Date(user.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—" }));
            case "actions":
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return navigate("/dashboard/users/".concat(user._id)); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:eye-linear", className: "text-lg text-gray-500" }) }), isAdmin && ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return navigate("/dashboard/users/".concat(user._id)); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear", className: "text-lg text-gray-500" }) })), isAdmin && user._id !== currentUserId && ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return handleDeactivateUser(user._id, user.name); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:user-block-linear", className: "text-lg text-red-500" }) }))] }));
            default:
                return user[columnKey];
        }
    }, [handleDeactivateUser, navigate, isAdmin, currentUserId]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white p-6 shadow-sm", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-semibold text-gray-900", children: "Users Management" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", isDisabled: !isAdmin, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:add-circle-linear", className: "text-lg" }), onPress: handleAddUser, children: "Add User" })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-end gap-3", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { className: "w-64", label: "Search", placeholder: "Search by name, email, contact...", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:magnifer-linear", className: "text-gray-400" }), value: searchQuery, onValueChange: setSearchQuery, variant: "bordered", size: "sm" }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, className: "w-48", label: "Role", placeholder: "Select role", variant: "bordered", size: "sm", selectedKeys: [roleFilter], onSelectionChange: function (keys) {
                            if (keys !== "all") {
                                setRoleFilter(Array.from(keys)[0]);
                                setPage(1);
                            }
                        }, children: constants_1.roleOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, className: "w-48", label: "Password Reset", placeholder: "Select", variant: "bordered", size: "sm", selectedKeys: [pwdResetFilter], onSelectionChange: function (keys) {
                            if (keys !== "all") {
                                setPwdResetFilter(Array.from(keys)[0]);
                                setPage(1);
                            }
                        }, children: constants_1.pwdResetOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", color: "primary", onPress: handleClearFilters, children: "Clear Filters" }), (0, jsx_runtime_1.jsxs)("div", { className: "ml-auto flex items-center gap-2 text-sm text-gray-500", children: ["Total Users: ", (0, jsx_runtime_1.jsx)("span", { className: "font-semibold text-gray-700", children: totalItems }), isFetching && (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white shadow-sm", children: (0, jsx_runtime_1.jsxs)(react_1.Table, { "aria-label": "Users table", classNames: {
                        wrapper: "min-h-[400px]",
                        th: "bg-gray-50 text-gray-600 font-semibold",
                        td: "py-4",
                    }, bottomContent: (0, jsx_runtime_1.jsxs)("div", { className: "flex w-full items-center justify-between border-t border-gray-100 px-4 py-4", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-gray-500", children: ["Showing ", start, " to ", end, " of ", totalItems, " users"] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-500", children: "Rows per page:" }), (0, jsx_runtime_1.jsx)(react_1.Select, { className: "w-20", size: "sm", variant: "bordered", selectedKeys: [String(rowsPerPage)], onSelectionChange: handleRowsPerPageChange, "aria-label": "Rows per page", children: constants_1.rowsPerPageOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) })] }), totalPages > 1 && (0, jsx_runtime_1.jsx)(react_1.Pagination, { isCompact: true, showControls: true, showShadow: true, color: "primary", page: page, total: totalPages, onChange: setPage })] })] }), children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, { columns: constants_1.columns, children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, { align: column.uid === "actions" ? "center" : "start", children: column.name }, column.uid)); } }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: users, emptyContent: isLoading || isFetching ? " " : "No users found", isLoading: isLoading || isFetching, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading users..." }), children: function (item) { return (0, jsx_runtime_1.jsx)(react_1.TableRow, { children: function (columnKey) { return (0, jsx_runtime_1.jsx)(react_1.TableCell, { children: renderCell(item, columnKey) }); } }, item._id); } })] }) })] }));
}
